import { STATUS, FALLBACK_STATUS, fmtTaipei } from './status';

interface Props {
  status: string;
  scheduledAt?: number | null;
}

/** 柔和 pill 狀態徽章；已排程時於下方顯示排程時間（台北時區）。 */
export default function StatusBadge({ status, scheduledAt }: Props) {
  const s = STATUS[status] ?? { ...FALLBACK_STATUS, text: status };
  return (
    <div className="flex flex-col gap-1">
      <span
        className={`inline-flex w-fit items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${s.pill}`}
      >
        <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
        {s.text}
      </span>
      {status === 'scheduled' && scheduledAt && (
        <span className="text-xs text-gray-400">{fmtTaipei(scheduledAt)}</span>
      )}
    </div>
  );
}
